module.exports = __webpack_public_path__ + "static/media/strutture-campo-beachvolley-piazza-noleggiocampi.344c661f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/campi/beachvolley/slider1/strutture-campo-beachvolley-piazza-noleggiocampi.jpg
// module id = 639
// module chunks = 0